// FAQ Collector - Collects FAQ data from collapsible content sections
class FAQCollector {
  constructor() {
    this.faqs = [];
    this.init();
  }

  init() {
    // Wait for DOM to be ready and add a small delay to ensure all content is loaded
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        setTimeout(() => this.collectFAQs(), 1000);
      });
    } else {
      setTimeout(() => this.collectFAQs(), 1000);
    }
  }

  collectFAQs() {
    console.log("Starting FAQ collection...");

    // Find all collapsible content sections
    const collapsibleSections = document.querySelectorAll(
      ".collapsible-content"
    );
    console.log("Found collapsible sections:", collapsibleSections.length);

    collapsibleSections.forEach((section, index) => {
      console.log(`Checking section ${index + 1}:`, section);

      // Check if this section has FAQ-related content
      const heading = section.querySelector(".collapsible-content__heading");
      console.log("Section heading:", heading);

      if (heading) {
        const headingText = heading.textContent.toLowerCase();
        console.log("Heading text:", headingText);

        // More flexible matching - check for any accordion content
        const hasAccordions =
          section.querySelectorAll(".accordion details").length > 0;
        console.log("Has accordions:", hasAccordions);

        if (
          headingText.includes("faq") ||
          headingText.includes("question") ||
          headingText.includes("help") ||
          hasAccordions
        ) {
          console.log("Extracting FAQs from section:", section);
          this.extractFAQsFromSection(section);
        }
      } else {
        // If no heading found, check if there are accordions anyway
        const hasAccordions =
          section.querySelectorAll(".accordion details").length > 0;
        if (hasAccordions) {
          console.log(
            "No heading but has accordions, extracting FAQs from section:",
            section
          );
          this.extractFAQsFromSection(section);
        }
      }
    });

    // Store FAQs in window object for global access
    window.collectedFAQs = this.faqs;

    // Insert structured data for SEO
    this.insertStructuredData();

    // Dispatch custom event when FAQs are collected
    document.dispatchEvent(
      new CustomEvent("faqsCollected", {
        detail: { faqs: this.faqs },
      })
    );

    console.log("Collected FAQs:", this.faqs);
  }

  extractFAQsFromSection(section) {
    const accordions = section.querySelectorAll(".accordion details");
    console.log("Found accordions in section:", accordions.length);

    accordions.forEach((accordion, index) => {
      console.log(`Processing accordion ${index + 1}:`, accordion);

      const summary = accordion.querySelector("summary");
      const content = accordion.querySelector(".accordion__content");

      console.log("Summary:", summary);
      console.log("Content:", content);

      if (summary && content) {
        const question = summary.querySelector(".accordion__title");
        console.log("Question element:", question);

        if (question) {
          const faq = {
            question: question.textContent.trim(),
            answer: this.stripHtml(content.textContent.trim()),
            sectionId: section.id || "unknown",
          };

          console.log("Extracted FAQ:", faq);
          this.faqs.push(faq);
        } else {
          console.log("No question element found in summary");
        }
      } else {
        console.log("Missing summary or content element");
      }
    });
  }

  stripHtml(html) {
    // Create a temporary div element
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }

  // Method to get FAQs as JSON-LD structured data
  getStructuredData() {
    if (this.faqs.length === 0) return null;

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: this.faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
    };

    return structuredData;
  }

  // Method to insert structured data script into the page
  insertStructuredData() {
    if (this.faqs.length === 0) {
      console.log("No FAQs to insert as structured data");
      return;
    }

    // Remove any existing FAQ structured data script
    const existingScript = document.querySelector(
      "script[data-faq-structured-data]"
    );
    if (existingScript) {
      existingScript.remove();
    }

    // Create the structured data
    const structuredData = this.getStructuredData();

    // Create the script element
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-faq-structured-data", "true");
    script.textContent = JSON.stringify(structuredData, null, 2);

    // Insert the script in the head
    document.head.appendChild(script);

    console.log("Inserted FAQ structured data:", structuredData);
  }

  // Method to render FAQs in a specific container
  renderFAQs(containerId) {
    const container = document.getElementById(containerId);
    if (!container || this.faqs.length === 0) return;

    let html =
      '<div class="faq-test-container" style="margin: 20px 0; padding: 20px; border: 1px solid #ccc; background: #f9f9f9;">';
    html += "<h3>Collected FAQs (Test Display)</h3>";

    this.faqs.forEach((faq, index) => {
      html += `
          <div style="margin-bottom: 15px; padding: 10px; border-left: 3px solid #007bff;">
            <strong>Q${index + 1}:</strong> ${faq.question}<br>
            <strong>A:</strong> ${faq.answer}
          </div>
        `;
    });

    html += "</div>";
    container.innerHTML = html;
  }
}

// Initialize FAQ Collector
const faqCollector = new FAQCollector();

// Export for global access
window.FAQCollector = FAQCollector;
window.faqCollector = faqCollector;

// Add manual collection method for debugging
window.collectFAQsManually = function () {
  console.log("Manual FAQ collection triggered");
  faqCollector.faqs = []; // Reset array
  faqCollector.collectFAQs();
};

// Add method to manually insert structured data
window.insertFAQStructuredData = function () {
  console.log("Manual structured data insertion triggered");
  faqCollector.insertStructuredData();
};

// Add method to check what sections are found
window.debugFAQCollection = function () {
  console.log("=== FAQ Collection Debug ===");
  const collapsibleSections = document.querySelectorAll(".collapsible-content");
  console.log("Total collapsible sections found:", collapsibleSections.length);

  collapsibleSections.forEach((section, index) => {
    console.log(`Section ${index + 1}:`, section);
    const heading = section.querySelector(".collapsible-content__heading");
    console.log("  Heading:", heading ? heading.textContent : "No heading");
    const accordions = section.querySelectorAll(".accordion details");
    console.log("  Accordions:", accordions.length);
  });

  console.log("Current collected FAQs:", window.collectedFAQs);
  console.log("========================");
};
